import { createAction } from 'redux-actions';

export const ROUTE_FROM_CROSS_SELL = 'ROUTE_FROM_CROSS_SELL';
export const routeFromCrossSell = createAction(ROUTE_FROM_CROSS_SELL);
